function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolycoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40px",
    height: "36px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#9147ff",
    d: "M 4.5,-0.5 C 14.1667,-0.5 23.8333,-0.5 33.5,-0.5C 35.792,0.789873 37.792,2.45654 39.5,4.5C 39.5,6.5 39.5,8.5 39.5,10.5C 36.1501,10.335 32.8168,10.5017 29.5,11C 23.6811,14.0983 23.0144,18.0983 27.5,23C 31.4862,23.4988 35.4862,23.6655 39.5,23.5C 39.5,25.5 39.5,27.5 39.5,29.5C 38.2101,31.792 36.5435,33.792 34.5,35.5C 24.8333,35.5 15.1667,35.5 5.5,35.5C 3.20799,34.2101 1.20799,32.5435 -0.5,30.5C -0.5,22.1667 -0.5,13.8333 -0.5,5.5C 0.789873,3.20799 2.45654,1.20799 4.5,-0.5 Z M 8.5,7.5 C 13.032,7.06919 17.3654,7.56919 21.5,9C 16.8333,9.66667 12.1667,9.66667 7.5,9C 8.05596,8.61742 8.38929,8.11742 8.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.821
    },
    fill: "#9147ff",
    d: "M 39.5,13.5 C 39.5,16.1667 39.5,18.8333 39.5,21.5C 35.8183,21.6653 32.1516,21.4986 28.5,21C 25.7501,17.9876 26.0834,15.321 29.5,13C 32.9236,12.2534 36.2569,12.42 39.5,13.5 Z M 30.5,16.5 C 33.7973,16.3287 34.1306,16.9954 31.5,18.5C 30.7025,18.0431 30.3691,17.3764 30.5,16.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolycoins);
export default __webpack_public_path__ + "static/media/polycoins.a99eb0aac22218fcf6bb5f06f83d885f.svg";
export { ForwardRef as ReactComponent };